import script from "./AudioGuideEndModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioGuideEndModal.vue?vue&type=script&setup=true&lang=js"

import "./AudioGuideEndModal.vue?vue&type=style&index=0&id=cd53b074&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd53b074"]])

export default __exports__